"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturesBar = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _index = require("../../atoms/FeatureTag/index");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var FeaturesBar = function FeaturesBar(_ref) {
  var features = _ref.features;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isIE = _useState2[0],
      setIsIE = _useState2[1];

  (0, _react.useEffect)(function () {
    var _window$navigator$use, _window$navigator$use2;

    setIsIE(((_window$navigator$use = window.navigator.userAgentString) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf("MSIE")) > -1 || ((_window$navigator$use2 = window.navigator.userAgentString) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.indexOf("rv:")) > -1);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    className: isIE ? "IEClass" : "gapClass",
    children: features !== undefined && features.map(function (feature, index) {
      return feature.value && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.FeatureTag, {
        feature: feature.feature,
        value: feature.value
      }, index);
    })
  });
};

exports.FeaturesBar = FeaturesBar;